export class PayrollAmountImpact {
    id: number;
    type: PayrollAmountImpactTypeEnum;
    description: string;
}

export enum PayrollAmountImpactTypeEnum {
    Reimbursement = 1,
    Expense = 2
}